import { render, staticRenderFns } from "./FlyerWindow.vue?vue&type=template&id=6580d0f9&scoped=true&"
import script from "./FlyerWindow.vue?vue&type=script&lang=js&"
export * from "./FlyerWindow.vue?vue&type=script&lang=js&"
import style0 from "./FlyerWindow.vue?vue&type=style&index=0&id=6580d0f9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6580d0f9",
  null
  
)

export default component.exports